import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getTelegramWebApp } from "../helpers/telegram";
import { parseMessageLaunch } from "../helpers/messageLaunch";

/** Launch parameters are untrusted; only the authenticated API can accept an answer. */
export function useMessageLaunch() {
    const navigate = useNavigate();
    const handled = useRef(false);
    useEffect(() => {
        if (
            handled.current ||
            import.meta.env.VITE_PB_MESSAGING_ENABLED !== "true"
        )
            return;
        handled.current = true;
        const token =
            getTelegramWebApp()?.initDataUnsafe.start_param ??
            new URLSearchParams(window.location.search).get(
                "tgWebAppStartParam",
            );
        const target = parseMessageLaunch(token);
        if (target) {
            navigate(target.pathname, {
                replace: true,
                state: {
                    messageActionToken: target.messageActionToken,
                },
            });
        }
    }, [navigate]);
}
